import Cookies from "js-cookie";

const COOKIE_OPTIONS = {
    secure: true,
    sameSite: "strict" as const,
};

export const setAccessToken = (accessToken: string): void => {
    Cookies.set("accessToken", accessToken, COOKIE_OPTIONS);
};

export const setRefreshToken = (refreshToken: string): void => {
    Cookies.set("refreshToken", refreshToken, {
        ...COOKIE_OPTIONS,
        expires: 30,
    });
};
